/**
 * Module: Grid
 * Child blocks
 * - Heading with Paragraph block
 * - Book list block
 * - Button block
 */

/**
 * External dependencies
 */

/**
 * DWT dependencies
 */

import {
  getInnerBlocks,
  lockInnerBlocks,
  passAttrsToInnerBlocks
} from '../utils/block-utils';

import { capitalizeFirstLetter } from '.././utils/general-utils';

import ListInspectorControls from '../block-components/ListInspectorControls';

/**
 * WP dependencies
 */

import {
  InspectorControls,
  useBlockProps,
  useInnerBlocksProps
} from '@wordpress/block-editor';

import {
  PanelBody,
} from '@wordpress/components';

import { __ } from '@wordpress/i18n';

const Edit = ({ attributes, setAttributes, clientId }) => {
  const {
    featureBy,
    filterBy,
    divisionCode,
    imprintCode,
    seriesCode,
    bisacCode,
    categoryCode,
    ageRangeCode,
    brandCode,
    themeCode,
    collectionISBNs,
    selectedFormats,
    selectedLanguages,
    selectedChildrensCategories,
    showMetadata,
    showCovers,
    hideAwardWinners,
    showBreadcrumb,
    showFormats,
    showLanguages,
    showChildrensCategories,
    filterByOptions
  } = attributes;

  /**
   * General settings/styles
   */

  const obj = {
    featureBy,
    filterBy,
    divisionCode,
    imprintCode,
    seriesCode,
    bisacCode,
    categoryCode,
    ageRangeCode,
    brandCode,
    themeCode,
    collectionISBNs,
    selectedFormats,
    selectedLanguages,
    selectedChildrensCategories,
    showMetadata,
    showCovers,
    hideAwardWinners,
    showBreadcrumb,
    filterByOptions
  };

  passAttrsToInnerBlocks( clientId, obj );

  /**
   * Block settings/styles
   */

  const blockProps = useBlockProps({
    className: `block__list-with-filters mt-25 mb-60 flex justify-center`
  });

  /**
   * innerBlocks settings/styles
   */

  const innerBlocks = getInnerBlocks( clientId );

  const template =
  [
    [ 'dwt/product-list', {} ]
  ];

  const { children, ...innerBlocksProps } = useInnerBlocksProps(
    { className: `inner-blocks-wrapper` },
    {
      allowedBlocks: [],
      template
    }
  );

  lockInnerBlocks( innerBlocks, 1, true );

  return (
    <>
      <InspectorControls>
        <PanelBody title={ __( 'Main settings', 'dwt-custom-theme' ) }>
          <ListInspectorControls
            setAttributes={ setAttributes }
            featureBy={ featureBy }
            filterBy={ filterBy }
            divisionCode={ divisionCode }
            imprintCode={ imprintCode }
            seriesCode={ seriesCode }
            bisacCode={ bisacCode }
            categoryCode={ categoryCode }
            ageRangeCode={ ageRangeCode }
            brandCode={ brandCode }
            themeCode={ themeCode }
            collectionISBNs={ collectionISBNs }
            selectedFormats={ selectedFormats }
            selectedLanguages={ selectedLanguages }
            selectedChildrensCategories={ selectedChildrensCategories }
            showMetadata={ showMetadata }
            showCovers={ showCovers }
            hideAwardWinners={ hideAwardWinners }
            showBreadcrumb={ showBreadcrumb }
            showFormats={ showFormats }
            showLanguages={ showLanguages }
            showChildrensCategories={ showChildrensCategories }
            filterByOptions={ filterByOptions }
            isProductList
            innerBlocks={ [] }
          />
        </PanelBody>
      </InspectorControls>

      <div { ...blockProps }>
        <div className='list-with-filters--inner block'>
          <div className='list-with-filters__heading mb-20'>
            <h3 className='heading-3 my-20'>Module: Product List with Filters</h3>
            <h4 className='heading-4 m-0'>{ capitalizeFirstLetter( featureBy ) }</h4>
          </div>
          <div { ...innerBlocksProps }>
            { children }
          </div>
        </div>
      </div>
    </>
  );
};

export default Edit;
